import Splide from '@splidejs/splide';
import SplideTrack from '@splidejs/splide';

export default class GridBanners {
	constructor() {
		if (jQuery(window).width() > 1023) {
			this.slider = document.querySelector('.gridBannersJs');

			if (this.slider) {
				this.events();
			}
		}
	}

	events() {
		window.addEventListener('DOMContentLoaded', () => {
			this.initializeSlider();
		});
	}

	initializeSlider() {
		this.mainSlider = new Splide(this.slider, {
			type: 'loop',
			perPage: 1,
			autoplay: true,
			interval: 5000,
			pauseOnHover: true,
			pauseOnFocus: true,
			resetProgress: false,
			pagination: false,
			arrows: true,
			arrowPath: 'M1.33325 5L10.6666 5M10.6666 5L6.66659 9M10.6666 5L6.66659 1',
		}).mount();

	}
}